module.exports = __webpack_public_path__ + "img/graycancel.9d36bb5e.svg";